import React from "react";
import { useState } from "react";

import { Typography, Button, Box } from "@mui/material";
import IntroImage from "../../../assets/OnboardingPage/intro-example.png";

const StepTwelveBreakIce1 = (props) => {
  //eslint-disable-next-line
  const [completed, setCompleted] = useState(true);

  return (
    <React.Fragment>
      <Typography variant="body2" sx={{ mt: "3rem", mb: 1, fontWeight: "bold" }}>
        YOUR FIRST ACTION
      </Typography>
      <Typography variant="h4" sx={{ fontWeight: "bold" }}>
        Introducing Yourself
      </Typography>
      <Typography variant="body1" sx={{ mt: "1rem" }}>
        Throughout this onboarding progress, you’ve been sculpting your ice cube
        to perfection.
      </Typography>
      <Typography variant="body1" sx={{ mt: "1rem" }}>
        Now, it’s time to break the ice, and get a special reward frozen inside!
        👀
      </Typography>
      <Typography variant="body1" sx={{ mt: "1rem", mb: "0.5rem" }}>
        Here's an example:
      </Typography>
      <img
        src={IntroImage}
        alt="IntroExampleImage"
        style={{ width: "100%", borderRadius: "5px", height: "auto" }}
      />
      <Button
        color="primary"
        variant="contained"
        fullWidth
        type="submit"
        sx={{ mt: "1rem" }}
        onClick={props.handleNext}
      >
        Break the ice
      </Button>
      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        <Button
          color="inherit"
          disabled={props.activeStep === 0}
          onClick={props.handleBack}
          sx={{ mr: 1 }}
        >
          Back
        </Button>
        <Box sx={{ flex: "1 1 auto" }} />
      </Box>
    </React.Fragment>
  );
};

export default StepTwelveBreakIce1;
